import { useContext, useState } from 'react';

import {
  ListSubheader,
  alpha,
  IconButton,
  Box,
  List,
  styled,
  Button,
  ListItem,
  Drawer
} from '@mui/material';
import { NavLink as RouterLink } from 'react-router-dom';
import { SidebarContext } from 'src/contexts/SidebarContext';

import DesignServicesTwoToneIcon from '@mui/icons-material/DesignServicesTwoTone';
import TableChartTwoToneIcon from '@mui/icons-material/TableChartTwoTone';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';

const MenuWrapper = styled(Box)(
  ({ theme }) => `
  .MuiList-root {
    padding: ${theme.spacing(1)};

    & > .MuiList-root {
      padding: 0 ${theme.spacing(0)} ${theme.spacing(1)};
    }
  }

    .MuiListSubheader-root {
      text-transform: uppercase;
      font-weight: bold;
      font-size: ${theme.typography.pxToRem(12)};
      color: ${theme.colors.alpha.trueWhite[50]};
      padding: ${theme.spacing(0, 2.5)};
      line-height: 1.4;
    }
`
);

const SubMenuWrapper = styled(Box)(
  ({ theme }) => `
    .MuiList-root {

      .MuiListItem-root {
        padding: 1px 0;

        .MuiBadge-root {
          position: absolute;
          right: ${theme.spacing(3.2)};

          .MuiBadge-standard {
            background: ${theme.colors.primary.main};
            font-size: ${theme.typography.pxToRem(10)};
            font-weight: bold;
            text-transform: uppercase;
            color: ${theme.palette.primary.contrastText};
          }
        }
    
        .MuiButton-root {
          display: flex;
          color: ${theme.colors.alpha.trueWhite[70]};
          background-color: transparent;
          width: 100%;
          justify-content: flex-start;
          padding: ${theme.spacing(1.2, 3)};

          .MuiButton-startIcon,
          .MuiButton-endIcon {
            transition: ${theme.transitions.create(['color'])};

            .MuiSvgIcon-root {
              font-size: inherit;
              transition: none;
            }
          }

          .MuiButton-startIcon {
            color: ${theme.colors.alpha.trueWhite[30]};
            font-size: ${theme.typography.pxToRem(20)};
            margin-right: ${theme.spacing(1)};
          }
          
          .MuiButton-endIcon {
            color: ${theme.colors.alpha.trueWhite[50]};
            margin-left: auto;
            opacity: .8;
            font-size: ${theme.typography.pxToRem(20)};
          }

          &.active,
          &:hover {
            background-color: ${alpha(theme.colors.alpha.trueWhite[100], 0.06)};
            color: ${theme.colors.alpha.trueWhite[100]};

            .MuiButton-startIcon,
            .MuiButton-endIcon {
              color: ${theme.colors.alpha.trueWhite[100]};
            }
          }
        }

        &.Mui-children {
          flex-direction: column;

          .MuiBadge-root {
            position: absolute;
            right: ${theme.spacing(7)};
          }
        }

        .MuiCollapse-root {
          width: 100%;

          .MuiList-root {
            padding: ${theme.spacing(1, 0)};
          }

          .MuiListItem-root {
            padding: 1px 0;

            .MuiButton-root {
              padding: ${theme.spacing(0.8, 3)};

              .MuiBadge-root {
                right: ${theme.spacing(3.2)};
              }

              &:before {
                content: ' ';
                background: ${theme.colors.alpha.trueWhite[100]};
                opacity: 0;
                transition: ${theme.transitions.create([
                  'transform',
                  'opacity'
                ])};
                width: 6px;
                height: 6px;
                transform: scale(0);
                transform-origin: center;
                border-radius: 20px;
                margin-right: ${theme.spacing(1.8)};
              }

              &.active,
              &:hover {

                &:before {
                  transform: scale(1);
                  opacity: 1;
                }
              }
            }
          }
        }
      }
    }
`
);

function SidebarMenu() {
  const { closeSidebar } = useContext(SidebarContext);
  const [isOpen, setIsOpen] = useState(false); // Initialize as false to hide the sidebar by default

  const toggleSidebar = () => {
    setIsOpen((prev) => !prev); // Toggle the sidebar visibility
  };

  return (
    <>
      <IconButton
        onClick={toggleSidebar}
        style={{ position: 'fixed', top: 20, left: 20, zIndex: 9999 }}
      >
        {isOpen ? <CloseIcon /> : <MenuIcon />}
      </IconButton>

      <Drawer
        anchor="left"
        open={isOpen}
        onClose={toggleSidebar}
        sx={{ '& .MuiDrawer-paper': { backgroundColor: '#11192a' } }} // Set drawer background color to black
      >
        {/* <img src='/static/images/avatars/admin.png' alt="My Image"  style={{width:"247px",marginTop:"10px",marginLeft:"8px",marginRight:"8px"}}/> */}
        <div
          style={{
            padding: '3px 10px', // adjust padding as needed
            backgroundColor: '#ffffff', // white background for padding
            display: 'inline-block' // keeps padding contained around the image
          }}
        >
          <img
            src="/static/images/avatars/admin.png"
            alt="My Image"
            style={{
              width: '247px',
              marginTop: '10px',
              marginLeft: '8px',
              marginRight: '8px'
            }}
          />
        </div>

        <MenuWrapper style={{ marginTop: '70px' }}>
          <List component="div">
            <SubMenuWrapper>
              <List component="div">
                <ListItem component="div">
                  <Button
                    disableRipple
                    component={RouterLink}
                    onClick={() => {
                      closeSidebar();
                      toggleSidebar(); // This will close the sidebar
                    }}
                    to="/dashboards/main"
                    startIcon={<DesignServicesTwoToneIcon />}
                  >
                    Dashboard
                  </Button>
                </ListItem>
              </List>
            </SubMenuWrapper>
          </List>

          <List
            component="div"
            subheader={
              <ListSubheader component="div" disableSticky>
                Users
              </ListSubheader>
            }
          >
            <SubMenuWrapper>
              <List component="div">
                <ListItem component="div">
                  <Button
                    disableRipple
                    component={RouterLink}
                    onClick={() => {
                      closeSidebar();
                      toggleSidebar(); // This will close the sidebar
                    }}
                    to="/users/list"
                    startIcon={<TableChartTwoToneIcon />}
                  >
                    Users List
                  </Button>
                </ListItem>

                <ListItem component="div">
                  <Button
                    disableRipple
                    component={RouterLink}
                    onClick={() => {
                      closeSidebar();
                      toggleSidebar(); // This will close the sidebar
                    }}
                    to="/users/add-user"
                    startIcon={<TableChartTwoToneIcon />}
                  >
                    Add User
                  </Button>
                </ListItem>

                <ListItem component="div">
                  <Button
                    disableRipple
                    component={RouterLink}
                    onClick={() => {
                      closeSidebar();
                      toggleSidebar(); // This will close the sidebar
                    }}
                    to="/userNotFound/list"
                    startIcon={<TableChartTwoToneIcon />}
                  >
                    New Request
                  </Button>
                </ListItem>
              </List>
              {/* </SubMenuWrapper>
            </List> */}
            </SubMenuWrapper>
          </List>

          <List
            component="div"
            subheader={
              <ListSubheader component="div" disableSticky>
                Announcement
              </ListSubheader>
            }
          >
            <SubMenuWrapper>
              <List component="div">
                <ListItem component="div">
                  <Button
                    disableRipple
                    component={RouterLink}
                    onClick={() => {
                      closeSidebar();
                      toggleSidebar(); // This will close the sidebar
                    }}
                    to="/notifications/list"
                    startIcon={<TableChartTwoToneIcon />}
                  >
                    Announcement List
                  </Button>
                </ListItem>

                <ListItem component="div">
                  <Button
                    disableRipple
                    component={RouterLink}
                    onClick={() => {
                      closeSidebar();
                      toggleSidebar(); // This will close the sidebar
                    }}
                    to="/notifications/add-notification"
                    startIcon={<TableChartTwoToneIcon />}
                  >
                    Add Announcement
                  </Button>
                </ListItem>
              </List>
            </SubMenuWrapper>
          </List>

          <List
            component="div"
            subheader={
              <ListSubheader component="div" disableSticky>
                Condolance
              </ListSubheader>
            }
          >
            <SubMenuWrapper>
              <List component="div">
                <ListItem component="div">
                  <Button
                    disableRipple
                    component={RouterLink}
                    onClick={() => {
                      closeSidebar();
                      toggleSidebar(); // This will close the sidebar
                    }}
                    to="/condolance-messages/list"
                    startIcon={<TableChartTwoToneIcon />}
                  >
                    Condolance List
                  </Button>
                </ListItem>
                
                <ListItem component="div">
                  <Button
                    disableRipple
                    component={RouterLink}
                    onClick={() => {
                      closeSidebar();
                      toggleSidebar(); // This will close the sidebar
                    }}
                    to="/condolance-messages"
                    startIcon={<TableChartTwoToneIcon />}
                  >
                    Add Condolance
                  </Button>
                </ListItem>
              </List>
            </SubMenuWrapper>
          </List>

          <List
            component="div"
            subheader={
              <ListSubheader component="div" disableSticky>
                Matrimonial
              </ListSubheader>
            }
          >
            <SubMenuWrapper>
              <List component="div">
                <ListItem component="div">
                  <Button
                    disableRipple
                    component={RouterLink}
                    onClick={() => {
                      closeSidebar();
                      toggleSidebar(); // This will close the sidebar
                    }}
                    to="/matrimonial/list"
                    startIcon={<TableChartTwoToneIcon />}
                  >
                    Matrimonial List
                  </Button>
                </ListItem>

                <ListItem component="div">
                  <Button
                    disableRipple
                    component={RouterLink}
                    onClick={() => {
                      closeSidebar();
                      toggleSidebar(); // This will close the sidebar
                    }}
                    to="/matrimonial/add"
                    startIcon={<TableChartTwoToneIcon />}
                  >
                    Add Matrimonial
                  </Button>
                </ListItem>
              </List>
            </SubMenuWrapper>
          </List>

          <List
            component="div"
            subheader={
              <ListSubheader component="div" disableSticky>
                Events
              </ListSubheader>
            }
          >
            <SubMenuWrapper>
              <List component="div">
                <ListItem component="div">
                  <Button
                    disableRipple
                    component={RouterLink}
                    onClick={() => {
                      closeSidebar();
                      toggleSidebar(); // This will close the sidebar
                    }}
                    to="/events/list"
                    startIcon={<TableChartTwoToneIcon />}
                  >
                    Events List
                  </Button>
                </ListItem>

                <ListItem component="div">
                  <Button
                    disableRipple
                    component={RouterLink}
                    onClick={() => {
                      closeSidebar();
                      toggleSidebar(); // This will close the sidebar
                    }}
                    to="/events/add"
                    startIcon={<TableChartTwoToneIcon />}
                  >
                    Add Event
                  </Button>
                </ListItem>
              </List>
            </SubMenuWrapper>
          </List>

          <List
            component="div"
            subheader={
              <ListSubheader component="div" disableSticky></ListSubheader>
            }
          >
            <SubMenuWrapper>
              <List component="div">
                <ListItem component="div">
                  <Button
                    disableRipple
                    component={RouterLink}
                    onClick={() => {
                      closeSidebar();
                      toggleSidebar(); // This will close the sidebar
                    }}
                    to="/contacts/list"
                    startIcon={<TableChartTwoToneIcon />}
                  >
                    Contact List
                  </Button>
                </ListItem>
              </List>
            </SubMenuWrapper>
          </List>

          <List
            component="div"
            subheader={
              <ListSubheader component="div" disableSticky>
                Gotra
              </ListSubheader>
            }
          >
            <SubMenuWrapper>
              <List component="div">
                <ListItem component="div">
                  <Button
                    disableRipple
                    component={RouterLink}
                    onClick={() => {
                      closeSidebar();
                      toggleSidebar(); // This will close the sidebar
                    }}
                    to="/gotra/list"
                    startIcon={<TableChartTwoToneIcon />}
                  >
                    Gotra List
                  </Button>
                </ListItem>

                <ListItem component="div">
                  <Button
                    disableRipple
                    component={RouterLink}
                    onClick={() => {
                      closeSidebar();
                      toggleSidebar(); // This will close the sidebar
                    }}
                    to="/gotra/add"
                    startIcon={<TableChartTwoToneIcon />}
                  >
                    Add Gotra
                  </Button>
                </ListItem>
              </List>
            </SubMenuWrapper>
          </List>

          <List
            component="div"
            subheader={
              <ListSubheader component="div" disableSticky>
                Homes
              </ListSubheader>
            }
          >
            <SubMenuWrapper>
              <List component="div">
                <ListItem component="div">
                  <Button
                    disableRipple
                    component={RouterLink}
                    onClick={() => {
                      closeSidebar();
                      toggleSidebar(); // This will close the sidebar
                    }}
                    to="/homes/edit"
                    startIcon={<TableChartTwoToneIcon />}
                  >
                    Homes Edit
                  </Button>
                </ListItem>
              </List>
            </SubMenuWrapper>
          </List>
          <List
            component="div"
            subheader={
              <ListSubheader component="div" disableSticky>
                Blogs
              </ListSubheader>
            }
          >
            <SubMenuWrapper>
            <List component="div">
              <ListItem component="div">
                <Button
                  disableRipple
                  component={RouterLink}
                  onClick={() => {
                    closeSidebar();
                    toggleSidebar(); // This will close the sidebar
                  }}
                  to="/blogs/list"
                  startIcon={<TableChartTwoToneIcon />}
                >
                  Blog List
                </Button>
              </ListItem>
             
                <ListItem component="div">
                  <Button
                    disableRipple
                    component={RouterLink}
                    onClick={() => {
                      closeSidebar();
                      toggleSidebar(); // This will close the sidebar
                    }}
                    to="/blogs/add-blog"
                    startIcon={<TableChartTwoToneIcon />}
                  >
                    Add Blog{' '}
                  </Button>
                </ListItem>
              </List>
             

            </SubMenuWrapper>
          </List>

          <List
            component="div"
            subheader={
              <ListSubheader component="div" disableSticky>
                Members
              </ListSubheader>
            }
          >
            <SubMenuWrapper>
              <List component="div">
                <ListItem component="div">
                  <Button
                    disableRipple
                    component={RouterLink}
                    onClick={() => {
                      closeSidebar();
                      toggleSidebar(); // This will close the sidebar
                    }}
                    to="/members/list"
                    startIcon={<TableChartTwoToneIcon />}
                  >
                    Members List
                  </Button>
                </ListItem>

                <ListItem component="div">
                  <Button
                    disableRipple
                    component={RouterLink}
                    onClick={() => {
                      closeSidebar();
                      toggleSidebar(); // This will close the sidebar
                    }}
                    to="/members/add"
                    startIcon={<TableChartTwoToneIcon />}
                  >
                    Add Members
                  </Button>
                </ListItem>
              </List>
            </SubMenuWrapper>
          </List>
        </MenuWrapper>
      </Drawer>
    </>
  );
}

export default SidebarMenu;
